
export const createTitle = (entries) => {
    return entries.map((entry) => ({ label: entry.label, key: entry.key }));
  };
  